<template>
  <ul class="dashboard-tasks-list">
    <tasks-item
      :task="task"
      v-for="task in tasks"
      :key="task.id"
    />
  </ul>
</template>

<script>
import TasksItem from './tasks-item'

export default {
  props: ['tasks'],
  components: {
    TasksItem
  }
}
</script>

<style lang="less">
.dashboard-task {
  &.acts {
    border-left-color: #3182ce;
  }
  &.law-cases {
    border-left-color: #5a67d8;
  }
  &.contragents {
    border-left-color: #805ad5;
  }
  &.roadmap {
    border-left-color: #38a169;
  }
  &.procedures {
    border-left-color: #ED64A6;
  }
  &.prepaids {
    border-left-color: #39B1AC;
  }
}
</style>
